<template>
  <div class="doughnut-container">
    <svg viewBox="0 0 120 120" class="doughnut">
      <!-- 배경 원 -->
      <circle
        cx="60"
        cy="60"
        r="50"
        fill="none"
        stroke="#333"
        :stroke-width="strokeWidth"
      />

      <!-- 진행 원 -->
      <circle
        cx="60"
        cy="60"
        r="50"
        fill="none"
        stroke="#EF4444"
        :stroke-width="strokeWidth"
        :stroke-dasharray="`${
          circumference * (percentage / 100)
        } ${circumference}`"
        stroke-linecap="round"
        transform="rotate(-90 60 60)"
      />
    </svg>

    <div class="center-text">
      <div class="hr-value">{{ maxHr }}</div>
      <div class="hr-unit">BPM</div>
      <div class="percentage">{{ percentage }}%</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoughnutChart",
  props: {
    maxHr: { type: Number, required: true },
    percentage: { type: Number, required: true },
  },
  data() {
    return {
      strokeWidth: 14,
      radius: 50,
    };
  },
  computed: {
    circumference() {
      return 2 * Math.PI * this.radius;
    },
  },
};
</script>

<style scoped>
.doughnut-container {
  position: relative;
  width: 116px;
  height: 116px;
  margin: 0 auto;
}

.doughnut {
  width: 100%;
  height: 100%;
}

.center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.hr-value {
  font-size: 24px;
  color: #fff;
  font-weight: 400;
  line-height: 1;
}

.hr-unit {
  font-size: 14px;
  color: #8e8e8e;
  margin-top: 2px;
}

.percentage {
  font-size: 12px;
  color: #8e8e8e;
  margin-top: 4px;
}
</style>
